import {
  onMounted,
  onUnmounted,
  ref,
  type Ref,
} from 'vue';
import { type IntervalID, requestInterval, clearRequestInterval } from 'src/lib/requestAnimationFrame';

export default function useUpdateTimer(now: Ref<Date>): void {
  const nowUpdateTimer = ref<IntervalID>();

  onMounted(() => {
    nowUpdateTimer.value = requestInterval(() => {
      now.value = new Date();
    }, 10 * 1000);
  });

  onUnmounted(() => {
    clearRequestInterval(nowUpdateTimer.value);
  });
}
